import { render } from "./DocumetFilters.vue?vue&type=template&id=39d3f61e&scoped=true"
import script from "./DocumetFilters.vue?vue&type=script&lang=js"
export * from "./DocumetFilters.vue?vue&type=script&lang=js"

import "./DocumetFilters.vue?vue&type=style&index=0&id=39d3f61e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d3f61e"]])

export default __exports__